/**
 * Accordions for the content-accordions treatment.
 *
 * The CMS gives us a flat run of headings and prose, so the wrapper each
 * heading toggles does not exist in the markup — this builds it.
 */
(function() {
    'use strict';

    function initAccordion(container) {
        var headings = container.querySelectorAll('h3, h4');

        if (headings.length === 0) return;

        headings.forEach(function(heading) {
            var content = [];
            var sibling = heading.nextElementSibling;

            while (sibling && !sibling.matches('h3, h4')) {
                content.push(sibling);
                sibling = sibling.nextElementSibling;
            }

            if (content.length === 0) return;

            var wrapper = document.createElement('div');
            wrapper.className = 'accordion-content';

            content.forEach(function(el) {
                wrapper.appendChild(el);
            });

            heading.parentNode.insertBefore(wrapper, heading.nextSibling);

            heading.addEventListener('click', function() {
                var isOpen = heading.classList.contains('accordion-open');

                heading.classList.toggle('accordion-open');
                wrapper.classList.toggle('accordion-open');

                // Announce state change for screen readers
                heading.setAttribute('aria-expanded', !isOpen);
            });

            heading.setAttribute('role', 'button');
            heading.setAttribute('aria-expanded', 'false');
            heading.setAttribute('tabindex', '0');

            heading.addEventListener('keydown', function(e) {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    heading.click();
                }
            });
        });
    }

    function initAllAccordions() {
        var containers = document.querySelectorAll('.content-accordions');
        containers.forEach(initAccordion);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initAllAccordions);
    } else {
        initAllAccordions();
    }
})();
